function AboutMe() {
  return (
    <div className="about-container" id="about">
      <h1 className="auth-heading">
        <b>About Me</b>
      </h1>
      <p className="auth-description">
        Hi, I'm Saurav Shete, a Full Stack Developer passionate about building
        interactive and visually appealing web applications 💻. With a strong
        foundation in the MERN Stack 🌱, I specialize in crafting seamless user
        experiences ✨ and writing clean, efficient code 💡. I love solving
        complex problems 🧩 and staying on the cutting edge of technology 🚀.
        I’m also exploring Android development, expanding my skills to mobile
        platforms 📱. I’m always looking for opportunities to work on exciting
        projects that challenge me to grow as a developer 📈. Let’s connect! 👋
      </p>
    </div>
  );
}

export default AboutMe;
